// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__snbYY","title":"Images45_title__1Un3a","images":"Images45_images__sxWPt"};